import React from 'react';
import {SYSTEMS} from '../utils/gameSystem';

export default React.createContext(SYSTEMS.ARIA);
